import './App.scss';
import { Routes, Route } from "react-router-dom";
import Home from './pages/home';
import AboutUs from './pages/about-us';
import Services from './pages/services';
import ContactUs from './pages/contact-us';
import Careers from './pages/careers';
import OurWorks from './pages/our-works';
import ScrollToTop from './components/scroll-to-top';
import CaseStudy from './pages/case-study';

// Referrence website
// https://uithemez.com/i/mivon_html/project-details.html

// horizontal gallery
// https://demos.gsap.com/demo/horizontal-scrolling-gallery
function App() {
  return (
    <>
    {/* Scroll to top when route changes */ }
    <ScrollToTop />
    <Routes>
      {/* <Route path="/" element={<Layout />}> */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/case-study" element={<CaseStudy />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/our-works" element={<OurWorks />} />
       {/* Catch-all route - redirects to home if route doesn't exist */}
      <Route path="*" element={<Home />} />
    </Routes>
    </>
    
  );
}

export default App;
